import React, { ReactNode } from 'react';

interface ListItemProps {
  children: string | ReactNode;
  render?: boolean;
}

function ListItem({ children, render }: ListItemProps) {
  if (!render) {
    return null;
  }

  return <li>{children}</li>;
}

ListItem.defaultProps = {
  render: true,
};

export default ListItem;
